import React from 'react'
import { useFormikContext } from 'formik'
import CardElement from '../../components/card.v2'
import TextAreaElement from '../../components/TextArea'
import SelectElement from '../../components/Select'
import { HoverBorderGradientDemo } from '../../components/Button'

const BioStep2 = ({ currentStep, setCurrentStep }) => {
  const { values, setFieldValue } = useFormikContext()
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFieldValue(`bio.${name}`, value) // Update userData dynamically
  }

  return (
    <div className='max-w-xl mx-auto'>
      <CardElement className={'w-full'}>
        <h2 className='text-gray-700 font-semibold mb-4 cursor-pointer'>
          <svg
            onClick={() => {
              setCurrentStep(currentStep - 1)
            }}
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth='2'
            stroke='currentColor'
            className='w-5 h-5'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M15 19l-7-7 7-7'
            />
          </svg>
        </h2>
        {/* Column 1 */}
        <div className='max-h-[170px] md:max-h-[calc(100vh-400px)] h-auto overflow-auto custom-scrollbar px-6'>
          <div className='my-4'>
            <SelectElement
              label={'Preferred Personality for AI'}
              placeholder={'Select Personality type'}
              name='personality'
              value={values?.bio?.personality || ''}
              onChange={handleInputChange}
              options={[
                { label: 'Professional', value: 'Professional' },
                { label: 'Empathetic', value: 'Empathetic' },
                { label: 'Neutral', value: 'Neutral' },
                { label: 'Custom', value: 'Custom' },
              ]}
            />
            {values?.bio?.personality == 'Custom' && (
              <TextAreaElement
                name='personalityDesc'
                value={values?.bio?.personalityDesc || ''}
                handleInputChange={handleInputChange}
                placeholder='Describe'
              />
            )}
          </div>

          <TextAreaElement
            label='Preferred Greeting Style'
            type='text'
            name='greeting'
            value={values?.bio?.greeting || ''}
            handleInputChange={handleInputChange}
            placeholder='Describe'
          />

          <div className='my-4'>
            <SelectElement
              label={'Preferred Language'}
              placeholder={'Select Language'}
              name='language'
              value={values?.bio?.language || ''}
              onChange={handleInputChange}
              options={[
                { label: 'English', value: 'en' },
                { label: 'Spanish', value: 'es' },
              ]}
            />
          </div>
        </div>

        {/* Submit Button */}
        <div className='md:col-span-2 md:flex md:justify-end sticky bottom-0'>
          <div className='mt-8'>
            <HoverBorderGradientDemo
              type='button'
              onClick={() => {
                setCurrentStep(currentStep + 1)
              }}
            >
              <span className='font-bold capitalize px-12'>Next</span>
            </HoverBorderGradientDemo>
          </div>
        </div>
      </CardElement>
    </div>
  )
}

export default BioStep2
